import React, { Component } from 'react'
import { connect } from 'react-redux'
import './arrow.css'
import dietStyle from '../../pages/dietStyle/dietStyle'
class Arrow extends Component {
  validateNext() {
    switch (this.props.page) {
      case 1: {
        return this.props.sexo !== ''
      }
      case 2: {
        return this.props.actividad_fisica !== ''
      }
      case 3: {
        return this.props.tipoalimentacion?.type !== ''
      }
      case 4: {
        return this.props.carnes.indexOf(true) >= 0
      }
      case 5: {
        return this.props.alergias.indexOf(true) >= 0
      }
      case 7: {
        return this.props.dietStyle > 0 && this.props.cantidadComidas > 0
      }
      case 6: {
        return this.props.maloshabitos.indexOf(true) >= 0
      }

      case 8: {
        return this.props.objetivo > 0
      }
      default:
        return true
    }
  }
  goToNextPage() {
    const withMeat = ['omnivora', 'pescetariana']
    if (this.validateNext()) {
      if (
        this.props.page === 3 &&
        !withMeat.includes(this.props.tipoalimentacion?.type)
      ) {
        this.props.changePage(5)
        return
      }
      this.props.changePage(this.props.page + 1)
    }
  }
  goToBackPage() {
    const withMeat = ['omnivora', 'pescetariana']
    if (
      this.props.page === 5 &&
      !withMeat.includes(this.props.tipoalimentacion?.type)
    ) {
      this.props.changePage(3)
      return
    }
    this.props.changePage(this.props.page - 1)
  }
  render() {
    return (
      <div className="arrows">
        <ul>
          {this.props.page !== 9 ? (
            <>
              <li className="disable" onClick={() => this.goToBackPage()}>
                <i className="fas fa-angle-left" /> Anterior
              </li>

              <li
                className={
                  'next ' + (this.validateNext() ? 'enable' : 'disable')
                }
                onClick={() => {
                  this.goToNextPage()
                }}
              >
                Siguiente <i className="fas fa-angle-right" />
              </li>
            </>
          ) : null}
        </ul>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  page: state.page,
  sexo: state.sexo,
  actividad_fisica: state.actividad_fisica,
  carnes: state.carnes,
  alergias: state.alergias,
  maloshabitos: state.maloshabitos,
  objetivo: state.objetivo,
  tipoalimentacion: state.tipoalimentacion,
  dietStyle: state.dietStyle,
  cantidadComidas: state.cantidadComidas,
})
const mapDispatchToProps = (dispatch) => ({
  changePage(page) {
    dispatch({
      type: 'CHANGE_PAGE',
      page: page,
    })
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(Arrow)
